export const NOOGIE = 'noogie'
